// src/components/shared/ErrorBoundary.jsx
import React, { Component } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Warning, Refresh } from '@mui/icons-material';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Actualizar estado para el siguiente render
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Capturar detalles del error
    this.setState({ error, errorInfo });
    
    // Opcionalmente, enviar error a servicio de monitoreo
    console.error('Error capturado por ErrorBoundary:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ 
      hasError: false,
      error: null,
      errorInfo: null 
    });
  }

  render() {
    const { fallback, children } = this.props;
    const { hasError, error } = this.state;

    if (hasError) {
      // Render fallback UI personalizado o el predeterminado
      if (fallback) {
        return fallback(error, this.handleReset);
      }

      return (
        <Paper sx={{ 
          p: 3, 
          m: 2, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          bgcolor: 'error.light',
          color: 'error.contrastText'
        }}>
          <Warning sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            Algo salió mal
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            {error?.message || 'Se ha producido un error en la aplicación.'}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={this.handleReset}
              startIcon={<Refresh />}
            >
              Intentar de nuevo
            </Button>
            <Button 
              variant="outlined" 
              onClick={() => window.location.reload()}
            >
              Recargar página
            </Button>
          </Box>
        </Paper>
      );
    }

    return children;
  }
}

export default ErrorBoundary;